const product = {
  product: "מוצר", // translated
  products: "מוצרים", // translated
  information: "מֵידָע", // translated
  additionalInformation: "מידע נוסף", // translated
  contactUs: "צור קשר", // translated
  contactUsText: "רוצה להתאים אישית את הסיור שלך או יש לך שאלות אחרות?", // translated
  dropUsAnEmail: "שלחו לנו מייל", // translated
  viewLess: "תראה פחות", // translated
  viewMore: "ראה עוד", // translated
  less: "פָּחוֹת", // translated
  more: "יותר", // translated
  highlights: "עיקרי הדברים", // translated
  inclusions: "תכלילים", // translated
  exclusions: "החרגות", // translated
  pleaseWait: "המתן בבקשה...", // translated
  tourType: "סוג סיור", // translated
  search: "לחפש", // translated
  available: "זמין", // translated
  availableTours: "סיורים זמינים", // translated
  sortBy: "מיין לפי", // translated
  priceLowToHigh: "מחיר מהנמוך לגבוה", // translated
  priceHighToLow: "מחיר: גבוה עד נמוך", // translated
  mostPopular: "הכי פופולארי", // translated
  roomOnly: "חדר בלבד", // translated
  bedAndBreakfast: "שינה וארוחת בוקר", // translated
  halfBoard: "חצי פנסיון", // translated
  fullBoard: "פנסיון מלא", // translated
  allInclusive: "הכל כלול", // translated
  viewDetails: "הצג פרטים", // translated
  close: "סגור", // translated
  at: "בְּ", // translated
  person: "אדם", // translated
  cancellationPolicy: "מדיניות ביטול", // translated
  cancellationIs: "ביטול הוא", // translated
  to: "ל", // translated
  bookingRemarks: "הערות הזמנה", // translated
  totalPrice: "מחיר סופי", // translated
  back: "חזור", // translated
  bookNow: "להזמין עכשיו", // translated
  minutes: "דקות", // translated
  visitDuration: "משך הביקור", // translated
  itinerary: "מַסלוּל", // translated
  airportToHotel: "משדה התעופה למלון", // translated
  hotelToAirport: "מלון לשדה התעופה", // translated
  details: "פרטים", // translated
  servicesDetails: "פרטי שירותים", // translated
  services: "שירותים", // translated
  day: "יְוֹם", // translated
  next: "הַבָּא", // translated
  nextStep: "השלב הבא", // translated
  skip: "לדלג", // translated
  remarks: "הערות", // translated
  optional: "אופציונאלי", // translated
  guests: "אורחים", // translated
  payment: "תַשְׁלוּם", // translated
  pickup: "לאסוף", // translated
  featuredPackage: "חבילה מומלצת", // translated
  flights: "טיסות", // translated
  accommodation: "דִיוּר", // translated
  transfers: "העברות", // translated
  tours: "סיורים", // translated
  experiences: "חוויות", // translated
  featuredTour: "סיור מומלץ", // translated
  From: "מ", // translated
  Accommodation: "דִיוּר", // translated
  approxDuration: "משוער. מֶשֶׁך", // translated
  travellerInformation: "מידע למטייל", // translated
  bookingOverview: "סקירת הזמנות", // translated
  checkout: "לבדוק", // translated
  paymentFailed: "התשלום נכשל", // translated
  paymentSuccess: "הצלחה בתשלום", // translated
  night: "לַיְלָה", // translated
  nights: "לילות", // translated
  viewEscapes: "צפה בבריחה", // translated
  viewExperience: "צפה בחוויה", // translated
  escapeType: "סוג בריחה", // translated
  adultsOnly: "למבוגרים בלבד", // translated
  totalDuration: "משך זמן כולל", // translated
  options: "אפשרויות", // translated
  departingAirport: "יציאה משדה התעופה", // translated
  childrenAreNotAllowedInThisTour: "ילדים אינם מורשים לסיור זה", // translated
};

export default product;
